import React, { useEffect, useMemo, useState } from "react";
import LoanPolicyComponent from "./LoanPolicyComponent";
import LeaveEncashmentPolicyComponent from "./LeaveEncashmentPolicyComponent";
import { usePermissions } from "../../../rbac/PermissionsContext";

export default function PayrollPoliciesTab({
  darkMode = false,
  canEdit = true,
  branchesList = [],
  departmentsList = [],
  designationsList = [],
  gradesList = [],
  categoriesList = [],
  subDepartmentsList = [],
}) {
  const { hasScreenAccess, isAdmin } = usePermissions() || {};
  const canViewLoan =
    isAdmin ||
    typeof hasScreenAccess !== "function" ||
    hasScreenAccess("payroll", "loan_policies", "view") ||
    hasScreenAccess("payroll", "loan_policies", "edit") ||
    hasScreenAccess("payroll", "loan_policies", "create");
  const canViewEncash =
    isAdmin ||
    typeof hasScreenAccess !== "function" ||
    hasScreenAccess("payroll", "leave_encashment_policies", "view") ||
    hasScreenAccess("payroll", "leave_encashment_policies", "edit") ||
    hasScreenAccess("payroll", "leave_encashment_policies", "create");
  const canEditLoan =
    canEdit &&
    (isAdmin ||
      typeof hasScreenAccess !== "function" ||
      hasScreenAccess("payroll", "loan_policies", "edit") ||
      hasScreenAccess("payroll", "loan_policies", "create"));
  const canEditEncash =
    canEdit &&
    (isAdmin ||
      typeof hasScreenAccess !== "function" ||
      hasScreenAccess("payroll", "leave_encashment_policies", "edit") ||
      hasScreenAccess("payroll", "leave_encashment_policies", "create"));

  const defaultKind = useMemo(() => {
    if (canViewLoan) return "loan";
    if (canViewEncash) return "encash";
    return null;
  }, [canViewLoan, canViewEncash]);

  const [kind, setKind] = useState(defaultKind);

  useEffect(() => {
    if (kind === "loan" && !canViewLoan) setKind(defaultKind);
    if (kind === "encash" && !canViewEncash) setKind(defaultKind);
    if (!kind && defaultKind) setKind(defaultKind);
  }, [kind, canViewLoan, canViewEncash, defaultKind]);

  if (!canViewLoan && !canViewEncash) {
    return (
      <p className="text-sm text-[hsl(var(--ds-muted-fg))]">
        You do not have permission to view payroll policies.
      </p>
    );
  }

  const masters = {
    darkMode,
    branchesList,
    departmentsList,
    designationsList,
    gradesList,
    categoriesList,
    subDepartmentsList,
  };

  return (
    <div className="flex min-h-0 flex-1 flex-col space-y-3">
      <div className="flex gap-2">
        {canViewLoan && (
          <button
            type="button"
            className={`rounded-full px-3 py-1 text-xs font-semibold ${
              kind === "loan"
                ? "bg-[hsl(var(--ds-primary))] text-[hsl(var(--ds-primary-fg))]"
                : "border border-[hsl(var(--ds-border))]"
            }`}
            onClick={() => setKind("loan")}
          >
            Loan policies
          </button>
        )}
        {canViewEncash && (
          <button
            type="button"
            className={`rounded-full px-3 py-1 text-xs font-semibold ${
              kind === "encash"
                ? "bg-[hsl(var(--ds-primary))] text-[hsl(var(--ds-primary-fg))]"
                : "border border-[hsl(var(--ds-border))]"
            }`}
            onClick={() => setKind("encash")}
          >
            Leave encashment policies
          </button>
        )}
      </div>
      {kind === "loan" && canViewLoan ? (
        <LoanPolicyComponent {...masters} canEdit={canEditLoan} />
      ) : null}
      {kind === "encash" && canViewEncash ? (
        <LeaveEncashmentPolicyComponent {...masters} canEdit={canEditEncash} />
      ) : null}
    </div>
  );
}
